var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { ref: "tform-0", attrs: { model: _vm.menuObj, "label-width": "0" } },
        [
          _c(
            "draggable",
            _vm._b(
              {
                staticClass: "dragArea",
                attrs: {
                  group: { name: "drag1", disabled: ".disabled" },
                  tag: "div",
                  list: _vm.menuList,
                  "component-data": _vm.getComponentData(),
                },
              },
              "draggable",
              _vm.dragOptions,
              false
            ),
            [
              _vm._l(_vm.menuObj.menuList, function (el, index) {
                return [
                  el
                    ? [
                        el.id && el.merchantId === 0 && el.status === 1
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticClass: "dragger-box drag-item disabled",
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "menuList." + index + ".name",
                                      rules: [
                                        {
                                          required: true,
                                          message: _vm.$t(
                                            "after-sales::after-sales-set::input_name_holder"
                                          ),
                                          trigger: "change",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input-item",
                                      attrs: {
                                        disabled: el.id && el.merchantId === 0,
                                      },
                                      model: {
                                        value: el.name,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            el,
                                            "name",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "el.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _c(
            "draggable",
            _vm._b(
              {
                staticClass: "dragArea",
                attrs: {
                  group: { name: "drag", disabled: ".disabled" },
                  tag: "div",
                  list: _vm.menuList,
                  "component-data": _vm.getComponentData(),
                },
              },
              "draggable",
              _vm.dragOptions,
              false
            ),
            [
              _vm._l(_vm.menuObj.menuList, function (el, index) {
                return [
                  el
                    ? [
                        (!el.id || el.merchantId > 0) && el.status === 1
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticClass: "dragger-box drag-item",
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "menuList." + index + ".name",
                                      rules: [
                                        {
                                          required: true,
                                          message: _vm.$t(
                                            "after-sales::after-sales-set::input_name_holder"
                                          ),
                                          trigger: "change",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticClass: "input-item",
                                        attrs: {
                                          disabled:
                                            el.id &&
                                            el.merchantId == 0 &&
                                            !_vm.authPromise(_vm.auth + "edit"),
                                          maxlength: "20",
                                          placeholder: _vm.$t(
                                            "after-sales::email-setting::please_input"
                                          ),
                                        },
                                        model: {
                                          value: el.name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              el,
                                              "name",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "el.name",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "prefix" }, [
                                          !el.id || el.merchantId > 0
                                            ? _c("i", {
                                                staticClass:
                                                  "iconfont iconSort drag-icon icon",
                                                attrs: {
                                                  title: _vm.$t(
                                                    "after-sales::after-sales-set::move"
                                                  ),
                                                },
                                              })
                                            : _vm._e(),
                                        ]),
                                        _c("template", { slot: "suffix" }, [
                                          !el.id || el.merchantId > 0
                                            ? _c("i", {
                                                directives: [
                                                  {
                                                    name: "auth",
                                                    rawName: "v-auth",
                                                    value: _vm.auth + "delete",
                                                    expression:
                                                      "`${auth}delete`",
                                                  },
                                                ],
                                                staticClass:
                                                  "el-icon-circle-close icon",
                                                attrs: {
                                                  title: _vm.$t(
                                                    "after-sales::after-sales-set::delete"
                                                  ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onDel(index)
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _c(
            "el-form-item",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: _vm.auth + "add",
                      expression: "`${auth}add`",
                    },
                  ],
                  attrs: { icon: "el-icon-plus" },
                  on: { click: _vm.addItem },
                },
                [_vm._v(_vm._s(_vm.buttonName))]
              ),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loading, type: "primary" },
                  on: { click: _vm.saveItem },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("after-sales::after-sales-set::add_save")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }